module.exports = __webpack_public_path__ + "img/menu-icon-events.47744b01.svg";